import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator.js';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner.js';
import AttributeOptions from './AttributeOptions.js';
import CustomAlert from './CustomAlert.js';

class CooperativeCompanyForm extends Component {

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const cooperative_company_options = [{id:0 , name:'Si'}, {id:1 , name:'No'}]
        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_cooperative_company" description="Cooperative Company"/>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveCooperativeCompany)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="cooperative_company" defaultValue="¿Es una cámara?" label="¿Es una cámara?" attributeName='cooperative_company' attributeOptions={cooperative_company_options}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

CooperativeCompanyForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'cooperative_company', required: true}])
CooperativeCompanyForm = TopScrolleable(CooperativeCompanyForm);

CooperativeCompanyForm = reduxForm({
    form: 'CooperativeCompanyForm', // a unique name for this form
    validate
})(CooperativeCompanyForm);

CooperativeCompanyForm = withAuthControl(CooperativeCompanyForm);

export default CooperativeCompanyForm;


/** WEBPACK FOOTER **
 ** ./src/components/CooperativeCompanyForm.js
 **/